module.exports = __webpack_public_path__ + "img/healthProMobile3-EN.2343410b.png";